// React Core
import React from 'react';

// Date/Time Utility
import moment from 'moment';

// Ant Design Components
import { Col, Row, Select, Typography } from 'antd';

// Apollo/GraphQL Hooks
import { useQuery } from '@apollo/client';

// GraphQL Queries
import { GET_INITIATIVES_LIST } from '../../graphql/queries';

// Custom/App Components
import { Loading } from '../Loading';

const { Option } = Select;

const { Text } = Typography;

const FiltersDrawer = ({ setInitiative, setInitiativeLabel }) => {
  const { loading: initiativesListLoading, data: initiativesListData } =
    useQuery(GET_INITIATIVES_LIST);

  if (initiativesListLoading) return <Loading />;

  return (
    <Row className="my-2">
      <Col xs={24}>
        <Text className="fw-bold">Initiative:</Text>
        <Select
          onChange={(value, option) => {
            setInitiative(value);
            setInitiativeLabel(option.children.join(' '));
          }}
          style={{ width: '100%' }}
          defaultValue=""
          className="mt-2"
        >
          <Option key="" value="">
            -----
          </Option>
          ,
          {initiativesListData?.initiatives?.edges.map(obj => (
            <Option key={obj.node.pk} value={obj.node.pk}>
              {obj.node.englishName} -&nbsp;
              {moment(obj.node.startingDate).format('DD/MM/YYYY')}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
  );
};

export default FiltersDrawer;
